import React from "react";
import { createPortal } from "react-dom";
import { GlobalStyles } from "@mui/material";
import PrintSummaryBlock from "../../BalanceSheet/components/PrintSummaryBlock";
import { PRINT_ROOT_CLASS, printStyles } from "../../BalanceSheet/utils/printStyles";
import { BriefReport } from "../types";

/**
 * Print-only copy of the Monthly Brief Report, portalled into <body>; the
 * shared print stylesheet hides the rest of the app. One month section per
 * printed page.
 */
const BriefPrintable: React.FC<{ report: BriefReport }> = ({ report }) => {
  const generated = new Date().toLocaleString("en-CA", { timeZone: "America/Toronto", dateStyle: "medium", timeStyle: "short" });

  return createPortal(
    <div className={PRINT_ROOT_CLASS} data-testid="brief-printable">
      <GlobalStyles styles={printStyles} />
      <header className="pr-header">
        <h1>{report.project.name}</h1>
        <h2>Monthly Brief Report</h2>
        <p>{report.label}</p>
      </header>

      {report.sections.map((section) => (
        <div className="pr-month" key={section.startDate}>
          <h2 className="pr-month-title">{section.label}</h2>
          <PrintSummaryBlock figures={section} />
        </div>
      ))}

      <footer className="pr-footer">
        <span>
          {report.project.name} · Monthly Brief Report · {report.label}
        </span>
        <span>Generated {generated}</span>
      </footer>
    </div>,
    document.body
  );
};

export default BriefPrintable;
